export enum SpendTypeEnum {
  ALL = '',
  GA = 'G&A',
  NON_GA = 'Non-G&A',
}

export const SPEND_TYPE_LABELS = {
  [SpendTypeEnum.ALL]: 'All Spend',
  [SpendTypeEnum.GA]: 'G&A',
  [SpendTypeEnum.NON_GA]: 'Non-G&A',
};

export const SPEND_TYPE_OPTIONS = [
  {
    label: SPEND_TYPE_LABELS[SpendTypeEnum.ALL],
    value: SpendTypeEnum.ALL,
  },
  {
    label: SPEND_TYPE_LABELS[SpendTypeEnum.GA],
    value: SpendTypeEnum.GA,
  },
  {
    label: SPEND_TYPE_LABELS[SpendTypeEnum.NON_GA],
    value: SpendTypeEnum.NON_GA,
  },
];

export enum CompareValueEnum {
  SPEND = 'spend',
  HEADCOUNT = 'headcount',
}

export const COMPARE_VALUE_LABELS = {
  [CompareValueEnum.SPEND]: 'Spend',
  [CompareValueEnum.HEADCOUNT]: 'Headcount',
};

export const COMPARE_VALUE_OPTIONS = [
  {
    label: COMPARE_VALUE_LABELS[CompareValueEnum.SPEND],
    value: CompareValueEnum.SPEND,
  },
  {
    label: COMPARE_VALUE_LABELS[CompareValueEnum.HEADCOUNT],
    value: CompareValueEnum.HEADCOUNT,
  },
];

export enum BenchmarkMetricEnum {
  GARTNER = 'Gartner',
  COMPUTER_ECONOMICS = 'Computer Economics',
}

export const BENCHMARK_METRIC_LABELS = {
  [BenchmarkMetricEnum.GARTNER]: 'Gartner',
  [BenchmarkMetricEnum.COMPUTER_ECONOMICS]: 'Computer Economics',
};

export const BENCHMARK_METRIC_TOTAL_PROPS = {
  [BenchmarkMetricEnum.GARTNER]: {
    medianValue: 'gartnerMedianValue',
    topQuartileValue: 'gartnerTopQuartileValue',
  },
  [BenchmarkMetricEnum.COMPUTER_ECONOMICS]: {
    medianValue: 'computerEconomicsMedianValue',
    topQuartileValue: 'computerEconomicsTopQuartileValue',
  },
};

export const BENCHMARK_METRIC_SPEND_OPTIONS = [
  {
    label: BENCHMARK_METRIC_LABELS[BenchmarkMetricEnum.GARTNER],
    value: BenchmarkMetricEnum.GARTNER,
  },
  {
    label: BENCHMARK_METRIC_LABELS[BenchmarkMetricEnum.COMPUTER_ECONOMICS],
    value: BenchmarkMetricEnum.COMPUTER_ECONOMICS,
  },
];

export const BENCHMARK_METRIC_HEADCOUNT_OPTIONS = [
  {
    label: BENCHMARK_METRIC_LABELS[BenchmarkMetricEnum.COMPUTER_ECONOMICS],
    value: BenchmarkMetricEnum.COMPUTER_ECONOMICS,
  },
];

export enum CompareCategoryEnum {
  SUMMARY = 'ExpenseType',
  SERVICE_TOWER = 'ServiceTower',
  JOB_ROLE = 'JobRole',
}

export const COMPARE_CATEGORY_LABELS = {
  [CompareCategoryEnum.SUMMARY]: 'Summary',
  [CompareCategoryEnum.SERVICE_TOWER]: 'Service Tower',
  [CompareCategoryEnum.JOB_ROLE]: 'Job Role',
};

export const COMPARE_CATEGORY_SPEND_OPTIONS = [
  {
    label: COMPARE_CATEGORY_LABELS[CompareCategoryEnum.SUMMARY],
    value: CompareCategoryEnum.SUMMARY,
  },
  {
    label: COMPARE_CATEGORY_LABELS[CompareCategoryEnum.SERVICE_TOWER],
    value: CompareCategoryEnum.SERVICE_TOWER,
  },
];

export const COMPARE_CATEGORY_HEADCOUNT_OPTIONS = [
  {
    label: COMPARE_CATEGORY_LABELS[CompareCategoryEnum.JOB_ROLE],
    value: CompareCategoryEnum.JOB_ROLE,
  },
];

export enum CompareByEnum {
  COST = 'Cost',
  PERCENT_OF_REVENUE = 'PercentageOfRevenue',
}

export const COMPARE_BY_LABELS = {
  [CompareByEnum.COST]: 'Cost',
  [CompareByEnum.PERCENT_OF_REVENUE]: 'Percent of revenue',
};

export const COMPARE_BY_OPTIONS = [
  {
    label: COMPARE_BY_LABELS[CompareByEnum.COST],
    value: CompareByEnum.COST,
  },
  {
    label: COMPARE_BY_LABELS[CompareByEnum.PERCENT_OF_REVENUE],
    value: CompareByEnum.PERCENT_OF_REVENUE,
  },
];

export enum ComapareTypeEnum {
  SIDE_BY_SIDE = 'sideBySide',
  DIFFERENCE = 'difference',
}

export const COMPARE_TYPE_LABELS = {
  [ComapareTypeEnum.SIDE_BY_SIDE]: 'Side by side',
  [ComapareTypeEnum.DIFFERENCE]: 'Difference',
};

export const COMPARE_TYPE_OPTIONS = [
  {
    label: COMPARE_TYPE_LABELS[ComapareTypeEnum.SIDE_BY_SIDE],
    value: ComapareTypeEnum.SIDE_BY_SIDE,
  },
  {
    label: COMPARE_TYPE_LABELS[ComapareTypeEnum.DIFFERENCE],
    value: ComapareTypeEnum.DIFFERENCE,
  },
];

export const CHART_COLORS = ['#275B81', '#4E92A1', '#89C2B3'];

export const HIGHLIGHT_COLOR = '#F2F2F2';

export const CHART_SERIES_LABELS = {
  peerMedian: 'Peer Median',
  topQuartile: 'Top Quartile',
  benchmark: 'Benchmark',
};
